import { EventsKey } from 'ol/events';
import BaseLayer from 'ol/layer/Base';
import LayerGroup from 'ol/layer/Group';

export const MONITOR_FOREGROUND_CLASS_NAME = 'ol-layer homemap-monitor-foreground';

export function keepMapLayersOnTop(layerGroup: LayerGroup, foregroundLayers: readonly BaseLayer[]): EventsKey {
    const initialZIndices = new Map<BaseLayer, number>();
    foregroundLayers.forEach((layer) => initialZIndices.set(layer, layer.getZIndex() ?? 0));
    const minimumZIndex = Math.min(...initialZIndices.values());
    let updating = false;

    const updateLayerOrder = (): void => {
        if (updating) {
            return;
        }

        const maximumZIndex = layerGroup.getLayerStatesArray().reduce((maximum, state) => {
            return initialZIndices.has(state.layer) ? maximum : Math.max(maximum, state.zIndex);
        }, 0);
        const offset = Math.max(0, maximumZIndex + 1 - minimumZIndex);

        updating = true;
        try {
            initialZIndices.forEach((initialZIndex, layer) => {
                const zIndex = initialZIndex + offset;
                if (layer.getZIndex() !== zIndex) {
                    layer.setZIndex(zIndex);
                }
            });
        } finally {
            updating = false;
        }
    };

    updateLayerOrder();
    return layerGroup.on('change', updateLayerOrder);
}
